module.exports = "<span *ngIf=\"!message\" id=\"snackMsg\">\r\n  <span id=\"snackText\">{{'The location has been switched to' | translate}}</span> <span id=\"snackHouseName\">{{houseName}}</span>.\r\n</span>\r\n\r\n<span *ngIf=\"message\" id=\"snackMsg\">\r\n  <span id=\"snackText\">{{message }}</span>.\r\n</span>"


//////////////////
// WEBPACK FOOTER
// ./src/app/layouts/gui-layout/sidebar-layout/snack-bar/snack-bar.component.html
// module id = ./src/app/layouts/gui-layout/sidebar-layout/snack-bar/snack-bar.component.html
// module chunks = main